import React, { useState, useEffect } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import MediaManager from '../components/MediaManager';
import { getOrganizations } from '../services/api';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const MediaManagerPage = ({ user, onLogout }) => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const orgsData = await getOrganizations();
      setOrganizations(orgsData?.results || []);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout user={user} onLogout={onLogout}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 200,
          }}
        >
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading media...</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout user={user} onLogout={onLogout}>
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
        <MediaManager organizations={organizations} />
      </Box>
    </DashboardLayout>
  );
};

export default MediaManagerPage;
